import type { Destructor } from "@suse-o11y/destructor";
import { onTimeout } from "@suse-o11y/on-timeout";

/**
 * Executes a callback function when the browser is idle.
 * If the browser supports `requestAnimationFrame`, it will use that to schedule the callback.
 * Otherwise, it will fallback to using `setTimeout`.
 *
 * @param callback - The callback function to be executed when the browser is idle.
 * @returns A cleanup function that can be used to cancel the idle callback.
 */
export function onFrame(callback: FrameRequestCallback): Destructor {
	// biome-ignore lint/style/noRestrictedGlobals: encapsulation
	if ("requestAnimationFrame" in window) {
		// biome-ignore lint/style/noRestrictedGlobals: encapsulation
		const idleId = window.requestAnimationFrame(callback);

		// biome-ignore lint/style/noRestrictedGlobals: encapsulation
		return () => window.cancelAnimationFrame(idleId);
	}

	return onTimeout(() => callback(performance.now()), 0);
}
